import { benefits, comparisonData } from "@/mocks/categories";

export default function WhySearchSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-6 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-4">
            Why VigorBuy
          </span>
          <h2 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">
            Why Users Search for VigorBuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Shoppers around the world rely on this resource for faster product discovery, better
            comparisons, and up-to-date information.
          </p>
        </div>

        {/* Benefit Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-14">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="group p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/70 hover:border-accent-200 transition-all duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mb-4 group-hover:bg-accent-200 transition-colors duration-200">
                <i className={`${benefit.icon} text-lg text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Comparison Table */}
        <div className="max-w-3xl mx-auto">
          <h3 className="text-xl font-heading text-foreground-900 text-center mb-6">
            Spreadsheet vs Traditional Search
          </h3>
          <div className="overflow-hidden rounded-xl border border-background-200/70">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-100">
                  <th className="text-left px-6 py-3.5 font-semibold text-foreground-700">
                    Feature
                  </th>
                  <th className="text-left px-6 py-3.5 font-semibold text-primary-700">
                    Spreadsheet
                  </th>
                  <th className="text-left px-6 py-3.5 font-semibold text-foreground-500">
                    Traditional Search
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, i) => (
                  <tr
                    key={row.feature}
                    className={`${
                      i % 2 === 0 ? "bg-background-50" : "bg-background-100/50"
                    }`}
                  >
                    <td className="px-6 py-3 font-medium text-foreground-800">
                      {row.feature}
                    </td>
                    <td className="px-6 py-3 text-primary-700 font-medium">
                      {row.spreadsheet}
                    </td>
                    <td className="px-6 py-3 text-foreground-500">
                      {row.traditional}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}